import image1 from "../images/user.jpg";
const authenticationItem = [
  { to: "login", name: "Login" },
  { to: "register", name: "Register" },
  { to: "recover_password", name: "recover Password" },
];

export const testmonalData = [
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd sohel",
  },
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd taleb",
  },
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd karim",
  },
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd rahim",
  },
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd jaker",
  },
  {
    text: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Explic",
    img: image1,
    name: "muhammd mahin mahi",
  },
];
export default authenticationItem;
